export const THEME = { primary:'#2b3945', accent:'#00e0ff', text:'#e8f0f8' } as const;
